<template>
  <div>
    <c-search-box :isShowSearch="false" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            type="search"
            name="plantCd"
            v-model="searchParam.plantCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="작업기간"
            name="permitDates"
            v-model="searchParam.permitDates"
            @input="getList"
          />
        </div>
        <div
          v-if="!popupParam.permitTypeCd"
          class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        >
          <c-select
            type="search"
            codeGroupCd="SOP_PERMIT_TYPE_CD"
            itemText="codeName"
            itemValue="code"
            name="permitTypeCd"
            label="허가서구분"
            v-model="searchParam.permitTypeCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-select
            type="search"
            codeGroupCd="SOP_SUPPLEMENT_WORK_TYPE_CD"
            itemText="codeName"
            itemValue="code"
            name="supplementWorkTypeCds"
            label="보충작업"
            v-model="searchParam.supplementWorkTypeCds"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            :comboItems="psmItems"
            itemText="codeName"
            itemValue="code"
            name="psmFlag"
            label="PSM 관련여부"
            v-model="searchParam.psmFlag"
            @input="getList"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="swpTable"
      title="작업허가서 목록"
      tableId="swp01"
      :filtering="false"
      :columnSetting="false"
      :isFullScreen="false"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      rowKey="sopWorkPermitId"
      :selection="popupParam.type"
      @linkClick="linkClick"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "safe-work-permit-pop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "single",
          plantCd: "",
          permitTypeCd: "",
          regUserId: "",
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        permitDates: [],
        applicationDeptCd: null,
        issuedDeptCd: null,
        permitTypeCd: null,
        supplementWorkTypeCds: [],
        swpStepCd: null,
        psmFlag: null,
      },
      grid: {
        columns: [
          {
            name: "workSummary",
            field: "workSummary",
            label: "작업개요",
            align: "left",
            sortable: true,
            type: "link",
            style: "width:200px",
          },
          {
            name: "permitDate",
            field: "permitDate",
            label: "허가일",
            align: "center",
            sortable: true,
            style: "width:80px",
          },
          {
            name: "permitTypeName",
            field: "permitTypeName",
            label: "허가서구분",
            align: "center",
            sortable: true,
            style: "width:70px",
          },
          {
            name: "supplementWorkTypeNames",
            field: "supplementWorkTypeNames",
            label: "보충작업",
            align: "left",
            sortable: true,
            style: "width:160px",
          },
          {
            name: "applicationDeptUserName",
            field: "applicationDeptUserName",
            label: "신청자",
            align: "center",
            sortable: true,
            style: "width:160px",
          },
          {
            name: "issuedDeptUserName",
            field: "issuedDeptUserName",
            label: "발급자",
            align: "center",
            sortable: true,
            style: "width:160px",
          },
          {
            name: "a",
            field: "a",
            label: "결재정보",
            child: [
              {
                name: "apprUser1Nm",
                field: "apprUser1Nm",
                label: "상신",
                align: "center",
                sortable: true,
                style: "width:80px",
              },
              {
                name: "apprUser2Nm",
                field: "apprUser2Nm",
                label: "합의",
                align: "center",
                sortable: true,
                style: "width:80px",
              },
              {
                name: "apprUser3Nm",
                field: "apprUser3Nm",
                label: "결재",
                align: "center",
                sortable: true,
                style: "width:80px",
              },
              {
                name: "apprUser4Nm",
                field: "apprUser4Nm",
                label: "확인",
                align: "center",
                sortable: true,
                style: "width:80px",
              },
              {
                name: "apprUser9Nm",
                field: "apprUser9Nm",
                label: "회람",
                align: "center",
                sortable: true,
                style: "width:80px",
              },
              {
                name: "apprUser10Nm",
                field: "apprUser10Nm",
                label: "재상신",
                align: "center",
                sortable: true,
                style: "width:80px",
              },
            ],
          },
        ],
        data: [],
        height: "500px",
      },
      psmItems: [
        { code: "Y", codeName: "관련 O" },
        { code: "N", codeName: "관련 X" },
      ],
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.swp.workPermit.list.url;
      // code setting
      this.searchParam.vendorCd = this.$store.getters.user.vendorCd;

      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd;
      }
      if (this.popupParam.permitTypeCd) {
        this.searchParam.permitTypeCd = this.popupParam.permitTypeCd;
      }
      if (this.popupParam.regUserId) {
        this.searchParam.regUserId = this.popupParam.regUserId;
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = "작업허가서";
      this.popupOptions.param = {
        sopWorkPermitId: row ? row.sopWorkPermitId : "",
        permitTypeCd: row ? row.permitTypeCd : "",
      };
      this.popupOptions.target = () =>
        import(`${"./safeWorkPermitDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      let selectData = this.$refs["swpTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "작업허가서를 지정하세요.", // 작업허가서를 지정하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
  },
};
</script>
